import { FaCheck } from "react-icons/fa"
import { useSelector } from "react-redux"

import CourseBuilderForm from "./CourseBuilder/CourseBuilderForm"
import CourseInformationForm from "./CourseInformation/CourseInformationForm"
import PublishCourse from "./PublishCourse"
import AssessmentForm from "./Assessment/AssessmentForm"

const STEPS = [
  { id: 1, title: "Course Info",  desc: "Title, price & category" },
  { id: 2, title: "Builder",      desc: "Sections & lectures" },
  { id: 3, title: "Publish",      desc: "Go live or draft" },
  { id: 4, title: "Assessment",   desc: "MCQ & challenges" },
]

export default function RenderSteps() {
  const { step } = useSelector((state) => state.course)

  return (
    <div>
      {/* Step indicator */}
      <div className="mb-8 flex items-start">
        {STEPS.map((s, idx) => (
          <div key={s.id} className="flex flex-1 items-start">
            <div className="flex flex-col items-center gap-1.5">
              {/* Circle */}
              <div
                className={`grid h-8 w-8 place-items-center rounded-full border-2 text-xs font-bold transition-all duration-300 sm:h-9 sm:w-9 sm:text-sm ${
                  step > s.id
                    ? "border-yellow-50 bg-yellow-50 text-richblack-900"
                    : step === s.id
                    ? "border-yellow-50 bg-yellow-900/40 text-yellow-50"
                    : "border-richblack-600 bg-richblack-800 text-richblack-500"
                }`}
              >
                {step > s.id ? <FaCheck size={12} /> : s.id}
              </div>
              {/* Label — always visible, truncated */}
              <div className="text-center" style={{ maxWidth: 72 }}>
                <p className={`truncate text-[10px] font-semibold leading-tight sm:text-xs ${
                  step >= s.id ? "text-richblack-5" : "text-richblack-500"
                }`}>
                  {s.title}
                </p>
                <p className="hidden truncate text-[10px] text-richblack-500 sm:block">{s.desc}</p>
              </div>
            </div>

            {/* Connector */}
            {idx < STEPS.length - 1 && (
              <div className="relative mx-1 mt-4 flex-1 sm:mx-2">
                <div className="h-0.5 w-full bg-richblack-600" />
                <div
                  className="absolute left-0 top-0 h-0.5 bg-yellow-50 transition-all duration-500"
                  style={{ width: step > s.id ? "100%" : "0%" }}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      {step === 1 && <CourseInformationForm />}
      {step === 2 && <CourseBuilderForm />}
      {step === 3 && <PublishCourse />}
      {step === 4 && <AssessmentForm />}
    </div>
  )
}
